import { render, staticRenderFns } from "./CartaoDespesas.vue?vue&type=template&id=77958a86&scoped=true"
import script from "./CartaoDespesas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDespesas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDespesas.vue?vue&type=style&index=0&id=77958a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77958a86",
  null
  
)

export default component.exports